module.exports = __webpack_public_path__ + "img/failure.31923a3b.svg";